"use strict";
var core_1 = require('./core');
exports.Stream = core_1.Stream;
exports.MemoryStream = core_1.MemoryStream;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = core_1.Stream;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xstream/index.js
// module id = 22
// module chunks = 0